'use strict';

goog.provide("Ntry.Code");

goog.require("Ntry.STATIC");

Ntry.Code = function(model) {
    var code = model.code;
    if (code) {
        if (code instanceof Entry.Code) this.code = code;
        else if (typeof code == "string")
            this.code = new Entry.Code(JSON.parse(code));
        else this.code = new Entry.Code(code);
    }
}

Ntry.Code.prototype.type = Ntry.STATIC.CODE;
